import axios from 'axios';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
} from '@mui/material';
import Button from '@mui/material/Button';

import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

export default function AddProfessionalCert({
  openModal,
  setOpenModal,
  fetchData,
}) {
  // const [openModal, setOpenModal] = useState(false);
  // const showModal = () => {
  //   setOpenModal(true);
  // };
  const { auth } = useAuth();
  const { userId } = useParams();
  const [getProfCert, setGetProfCert] = useState([]);

  const [getItem, setGetItem] = useState([]);
  const [role, setRole] = useState('doctor');

  React.useEffect(() => {
    if (auth?.idToken) {
      axios
        .get(`${url}/admin/certificate-items?role=${role}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setGetItem(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, userId]);

  const handleAProfCert = () => {
    const formData = {
      certificate: getProfCert.certificate,
      file: getProfCert.file,
    };

    axios
      .post(`${url}/admin/certificates/${userId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        console.log('Cert updated successfully:', response);
        setGetProfCert({ ...getProfCert });
        fetchData();
        toast.success('Cert updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.log(error.message);
        toast.error('Select type is required', {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  };

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFile = (e) => {
    const files = e.target.files[0];
    if (files) {
      setSelectedFile(files.name);
      setGetProfCert((prevInput) => ({
        ...prevInput,
        file: files,
      }));
    }
  };
  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModal}
      onClose={() => setOpenModal(false)}
    >
      <DialogTitle>Add new professional cert</DialogTitle>
      <br />

      <DialogContent>
        <div className='flex justify-between'>
          <Select
            fullWidth
            displayEmpty
            value={getProfCert?.certificate}
            onChange={(e) =>
              setGetProfCert({
                ...getProfCert,
                certificate: e.target.value,
              })
            }
            sx={{ mt: 1, mb: '16px', borderRadius: '8px', width: '500px' }}
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                style: {
                  zIndex: 1302,
                },
              },
            }}
            renderValue={(selected) => {
              if (!selected)
                return <span style={{ color: '#8C8C8C' }}>Select one</span>;
              const selectedItem = getItem?.find(
                (item) => item?._id === selected,
              );
              return selectedItem ? selectedItem.item : selected;
            }}
          >
            {getItem?.map((item) => (
              <MenuItem key={item?._id} value={item?._id}>
                {item?.item}
              </MenuItem>
            ))}
          </Select>
          &nbsp; &nbsp;
          <input
            type='file'
            id='profCert'
            accept='image/jpeg, image/png, image/webp, image/svg+xml, application/pdf'
            onChange={handleFile}
            className='text-md w-1/3'
          />
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => setOpenModal(false)}
          color='secondary'
        >
          Done
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => {
            handleAProfCert();
            setOpenModal(false);
          }}
          color='primary'
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
